import * as React from 'react';
import type { SVGProps } from 'react';
const SvgMenuBarsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={47}
    height={34}
    fill="none"
    viewBox="0 0 41 32"
    {...props}
  >
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M41 1H0M41 16H0M41 31H0"
    />
  </svg>
);
export default SvgMenuBarsIcon;
